import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminUsers;

export const adminUsersSelector = createSelector(getState, (state) => state.users);
export const adminUsersMetaSelector = createSelector(getState, (state) => state.usersMeta);
export const isLoadingUsersSelector = createSelector(getState, (state) => state.isLoadingUsers);

export const selectedUserSelector = createSelector(getState, (state) => state.selectedUser);
export const isLoadingUserSelector = createSelector(getState, (state) => state.isLoadingUser);

export const adminUserErrorsSelector = createSelector(getState, (state) => state.errors);
